import { ProjectSite } from 'models/Project';

export interface Project {
  id: string;
  name: string;
  devurl?: string;
  hostnames: string[];
  allowEmailTasks: boolean;
  allowEmailComments: boolean;
  isPublic: boolean;
  organizationId: string;
  apiKey: string;
  guestPermission: string;
  sites: ProjectSite[];
  ignoredQuerystrings: string[];
  allowProjectSummaryEmail: boolean;
  allowProjectOwnerNotifications: boolean;
  allowTaskDoneEmail: boolean;
  changeGuestDefaultColumn: boolean;
  ownerId: string;
  owner: {
    id: string;
    email: string;
    name: string;
  };
  membersOnProject: {
    id: string;
    email: string;
    name: string;
  }[];
  experiments?: string[];
  aiSuggestedTags?: boolean;
  aiSuggestedTitles?: boolean;
  aiDuplicateTasks?: boolean;
  aiSuggestedTagsExistingOnly?: boolean;
  aiSuggestedTitlesDefaultLanguage?: string;
  orgAiSuggestedTags?: boolean;
  orgAiSuggestedTitles?: boolean;
  orgAiDuplicateTasks?: boolean;
  orgAiSuggestedTagsExistingOnly?: boolean;
  orgAiSuggestedTitlesDefaultLanguage?: string;
}

export type ProjectSiteData = {
  project?: {
    id: string;
    feedbackUrl?: string;
  };
  projectSite?: { id: string };
};

export enum ProjectFormField {
  AllowGuestPermission = 'allowGuestPermission',
  AllowEmailTasks = 'allowEmailTasks',
  AllowEmailComments = 'allowEmailComments',
  AllowProjectOwnerNotifications = 'allowProjectOwnerNotifications',
  ChangeGuestDefaultColumn = 'changeGuestDefaultColumn',
  OwnerId = 'ownerId',
  Name = 'name',
  IgnoreList = 'ignoredQuerystrings',
  AiSuggestedTags = 'aiSuggestedTags',
  AiSuggestedTitles = 'aiSuggestedTitles',
  AiDuplicateTasks = 'aiDuplicateTasks',
  AiSuggestedTagsExistingOnly = 'aiSuggestedTagsExistingOnly',
  AiSuggestedTitlesDefaultLanguage = 'aiSuggestedTitlesDefaultLanguage'
}
